// Recovered compiled webpack factory 10160. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { A: () => a });
  var n = r(69142);
  function a(e, t) {
    var r, a;
    let i = t?.getDsn(),
      s = t?.getOptions().tunnel;
    return (
      (function (e, t) {
        let r = (0, n.kg)(e);
        return (
          !(!r || (0, n.nt)(r)) &&
          !!t &&
          r.host.includes(t.host) &&
          /(^|&|\?)sentry_key=/.test(r.search)
        );
      })(e, i) || ((r = e), !!(a = s) && o(r) === o(a))
    );
  }
  function o(e) {
    return "/" === e[e.length - 1] ? e.slice(0, -1) : e;
  }
}
